import { render, staticRenderFns } from "./StageExpand.vue?vue&type=template&id=16a6313c&scoped=true"
import script from "./StageExpand.vue?vue&type=script&lang=js"
export * from "./StageExpand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a6313c",
  null
  
)

export default component.exports